import React from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { connect } from 'react-redux';

import { Card } from '@atlaskit/media-card';
import { FileIdentifier } from '@atlaskit/media-client';
import { MediaClientConfig } from '@atlaskit/media-core';
import { gridSize } from '@atlaskit/theme';

import { BucketState } from 'src/types/state';

import FileLoading from '../components/file-loading';
import { LfsMedia } from '../types';

type Props = {
  downloadUrl: string;
  lfsMedia?: LfsMedia;
};

const mapStateToProps = (state: BucketState) => {
  const { lfs } = state.repository.source.file;
  return { lfsMedia: lfs ? lfs.media : undefined };
};

const CardWrapper = styled.div`
  padding: ${gridSize() * 4}px;

  > div {
    display: flex;
    justify-content: center;
  }
`;

// TODO: Replace usage of unsafe lifecycle methods
// eslint-disable-next-line react/no-unsafe
class LfsFile extends React.Component<Props> {
  mediaClientConfig: MediaClientConfig | null;

  componentDidMount() {
    this.updateLfsContext(this.props);
  }

  /* eslint react/no-unsafe: "warn" */
  // @ts-ignore TODO: fix noImplicitAny error here
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.lfsMedia !== nextProps.lfsMedia) {
      this.updateLfsContext(nextProps);
    }
  }

  downloadFile = () => {
    window.open(this.props.downloadUrl);
  };

  updateLfsContext = (props: Props) => {
    const { lfsMedia } = props;
    if (lfsMedia) {
      this.mediaClientConfig = {
        authProvider: () =>
          Promise.resolve({
            baseUrl: lfsMedia.api_url,
            clientId: lfsMedia.auth_qs.client,
            token: lfsMedia.auth_qs.token,
          }),
      };
    }
  };

  render() {
    const { lfsMedia } = this.props;

    if (!lfsMedia || !this.mediaClientConfig) {
      return <FileLoading />;
    }

    const identifier: FileIdentifier = {
      mediaItemType: 'file',
      id: lfsMedia.file_uuid,
      collectionName: '',
    };

    return (
      <CardWrapper>
        <Card
          mediaClientConfig={this.mediaClientConfig}
          identifier={identifier}
          onClick={this.downloadFile}
        />
      </CardWrapper>
    );
  }
}

export default connect(mapStateToProps)(LfsFile);
